import { render, staticRenderFns } from "./personMessage.vue?vue&type=template&id=c8c529b2&scoped=true&"
import script from "./personMessage.vue?vue&type=script&lang=js&"
export * from "./personMessage.vue?vue&type=script&lang=js&"
import style0 from "./personMessage.vue?vue&type=style&index=0&id=c8c529b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c529b2",
  null
  
)

export default component.exports